"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var styled_components_1 = __importDefault(require("styled-components"));
var App_1 = require("../../App");
var Head = styled_components_1.default.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  border: ", ";\n  border-radius: 10px;\n  font-size: ", ";\n  color: ", ";\n  font-weight: 400;\n  ", "\n  )\n"], ["\n  display: inline-block;\n  border: ", ";\n  border-radius: 10px;\n  font-size: ", ";\n  color: ", ";\n  font-weight: 400;\n  ", "\n  )\n"])), function (props) {
    return !props.$border
        ? "none"
        : props.$mode === "chalk"
            ? "4px solid rgba(255,255,255,.8)"
            : "4px solid black";
}, function (props) { return props.size; }, function (props) { return props.color; }, function (props) { return (props.$handWritten ? " font-family: 'Caveat', cursive  ;" : ""); });
var Heading = function (props) {
    var _a = (0, App_1.useEloise)(), theme = _a.theme, logic = _a.logic;
    var navigate = (0, react_router_1.useNavigate)();
    // Use the heading properties from the theme if they are not provided in props
    var _b = __assign(__assign({}, theme.heading), props), color = _b.color, size = _b.size, border = _b.border, handWritten = _b.handWritten, inverse = _b.inverse;
    var handleClick = function () {
        if (props.link) {
            navigate(props.link);
        }
    };
    var fontSize;
    if (size && typeof size !== "number") {
        fontSize = size;
    }
    else {
        switch (size) {
            case 2:
                fontSize = "1.3rem";
                break;
            case 3:
                fontSize = "1.6rem";
                break;
            case 4:
                fontSize = "2rem";
                break;
            case 5:
                fontSize = "2.5rem";
                break;
            case 6:
                fontSize = "4.5rem";
                break;
            default:
                fontSize = "1rem";
                break;
        }
    }
    return (react_1.default.createElement("div", { style: __assign(__assign({}, props.parentStyle), { padding: props.margin ? props.margin : " 0", textAlign: props.align ? props.align : "center", cursor: props.link ? "pointer" : "default" }), className: props.posClassName, onClick: props.link ? handleClick : function () { } },
        react_1.default.createElement(Head, { "$border": border ? border : false, style: __assign(__assign({}, props.style), { fontFamily: theme.font }), className: props.className, color: color
                ? typeof color === "number"
                    ? logic.color.convertToHSLA(theme.colors[color])
                    : color
                : "black", size: fontSize, "$handWritten": handWritten ? handWritten : false, "$inverse": inverse }, props.children)));
};
exports.Heading = Heading;
var templateObject_1;
